import { RootState } from "store/store";

export const selectSaveTemplateRequestStatus = (state: RootState) => state.templates.saveTemplateRequestStatus;
export const selectTemplates = (state: RootState) => state.templates.templates;